import {CUSTOM_ELEMENTS_SCHEMA, NgModule, Type} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {
  OrderConfirmationOrderInfoComponent
} from './order-confirmation-order-info/order-confirmation-order-info.component';
import {
  OrderConfirmationBuyerEmailComponent
} from './order-confirmation-buyer-email/order-confirmation-buyer-email.component';
import {
  OrderConfirmationListItemComponent
} from './order-confirmation-list-item/order-confirmation-list-item.component';
import {ModalModule} from 'ng-design-system';
import {ProvidedByModule} from '../provided-by/provided-by.module';
import {ErrorIndicatorModule} from '@app/shared/error-indicator/error-indicator.module';
import {MetricTextModule} from '@app/shared/metric-text/metric-text.module';
import {BundleProvidedByModule} from '../bundle-provided-by/bundle-provided-by.module';
import {OrderItemModule} from '../order-item/order-item.module';
import {OrderTableModule} from '../order-table/order-table.module';
import {DerivativeEntryListModule} from '../derivative-entry-list/derivative-entry-list.module';
import {GroupTotalModule} from '../group-total/group-total.module';
import {RecurringTotalModule} from '../recurring-total/recurring-total.module';
import {DcpDateFormatterModule} from '@dcp/configurator';

const orderConfirmationComponents: Array<Type<any>> = [
  OrderConfirmationBuyerEmailComponent,
  OrderConfirmationOrderInfoComponent,
  OrderConfirmationListItemComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OrderConfirmationBuyerEmailComponent: {
          component: OrderConfirmationBuyerEmailComponent
        },
        OrderConfirmationOrderInfoComponent: {
          component: OrderConfirmationOrderInfoComponent
        },
        OrderConfirmationListItemComponent: {
          component: OrderConfirmationListItemComponent,
        },
      }
    }),
    I18nModule,
    DcpDateFormatterModule,
    ModalModule,
    ProvidedByModule,
    ErrorIndicatorModule,
    MetricTextModule,
    BundleProvidedByModule,
    OrderItemModule,
    OrderTableModule,
    DerivativeEntryListModule,
    GroupTotalModule,
    RecurringTotalModule,
  ],
  providers: [],
  declarations: [...orderConfirmationComponents],
  exports: [...orderConfirmationComponents],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class DcpOrderConfirmationModule {
}
